// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3lvwj","location":"Header_location__1LF94"};